import { FC } from 'react';
import { TDividerProps } from './Divider.types';
import SDivider from './Divider.styles';

const Divider: FC<TDividerProps> = (props) => {
  return <SDivider {...props} />;
};

export default Divider;
